<span class="p-float-label">
    <input
      type="text"
      [(ngModel)]="value"
      (touchend)="_onTouched()"
      [style]="{ width: '100%' }"
      [mask]="'00.00.0000'"
      [showMaskTyped]="true"
      [dropSpecialCharacters]="false"
      inputmode="numeric"
      [disabled]="disabled"
      pInputText
    />
    <label>{{ label }}</label>
</span>
